import type { Feature } from '@luna/gatekeeper';

export const orderReplacementCard: Feature = {
    enabled: false,
    _description: 'Displays replacement card order focus page - CZ and RO only',
};
